import { Modal, Col, Row, Button, Form, message } from "antd";
import { useTranslation } from "react-i18next";
import Title from "../../../UI/Title/Title";
import Pay from "../PayWithCash/pay";
import React, { useState, useEffect, useContext } from "react";
import { useMutation } from "react-query";
import { mainActions } from "../../../../store/main/mainSlice";
import { handleMakePayment, handleFinalizePayment } from "../../CheckoutNew";
import { useDispatch, useSelector } from "react-redux";
import { Sale, createReceipt, createSale } from "../../../../api/sales";
import { CreditCard } from "../CreditCard/creditcard";
import { OnAccount } from "../OnAccount/OnAccount";

import {
  ChangeStateContext,
  exchangeRateContext,
  returnedContext,
  tenderedLBPContext,
} from "../../MainFour";
import { useRef, Dispatch, SetStateAction } from "react";
import Delivery from "../Delivery/delivery";
import moment from "moment";

type propsType = {
  isOpenProceed: boolean;
  setIsOpenProceed: React.Dispatch<React.SetStateAction<boolean>>;
  isPayOpen: boolean;
  setIsPayOpen: Dispatch<SetStateAction<boolean>>;
  deliveryCharge: number | null;
  setDeliveryCharge: Dispatch<SetStateAction<any>>;
};
export const setOpenProceed = React.createContext<any>(null);
export const ProceedPayment = ({
  isOpenProceed,
  setIsOpenProceed,
  isPayOpen,
  setIsPayOpen,
  deliveryCharge,
  setDeliveryCharge
}: propsType) => {
  const [t] = useTranslation("common");
  const [isOpenDelivery, setIsOpenDelivery] = useState(false)
  const [isOpenCrediCard, setIsOpenCreditCard] = useState(false);
  const [isOnAccountOpen, setIsOnAccountOpen] = useState(false);
  const { exchangeRate } = useContext(exchangeRateContext);

  /*Pay With Cash */
  const mainCurrencyString = localStorage.getItem("mainCurrency");
  const mainCurrency = mainCurrencyString
    ? JSON.parse(mainCurrencyString)
    : null;
  const { tenderedLBP, setTenderedLBP } = useContext(tenderedLBPContext);
  const [currency, setCurrency] = useState<any>(mainCurrency);
  const [selectedCurrency, setSelectedCurrency] = useState(mainCurrency?.id);
  const dispatch = useDispatch();
  const customer = useSelector((state: any) => state?.main?.customer);
  const items = useSelector((state: any) => state?.main?.items);
  const discount = useSelector((state: any) => state.main.discount);
  const exchangeRates = useSelector((state: any) => state.main.exchangeRate);
  const totalPrice = useSelector((state: any) => state.main.totalPrice);
  const { tenderedUSD, setTenderedUSD } = useContext(ChangeStateContext);
  const { setReturnedUSD, setReturnedLBP } = useContext(returnedContext);
  const { mutateAsync: createSaleMutation, isLoading: isLoadingSaleMutation } = useMutation(
    "createSale",
    (body: Sale) => createSale(body)
  );
  const { mutateAsync: createReceiptMutation } = useMutation(
    "createReceipt",
    (body: any) => createReceipt(body)
  );

  useEffect(() => {
    setTimeout(() => {
      cashRef.current?.focus();
    }, 0);
    setSelectedCurrency(mainCurrency?.id);
    setCurrency(mainCurrency);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpenProceed]);

  const [form] = Form.useForm();
  const cashRef = useRef<HTMLElement>(null);
  const sessionId = useRef(localStorage.getItem("sessionId"));
  const invoiceNo = useSelector((state: any) => state.main.invoiceNo);
  const [isPaid, setIsPaid] = useState(false);
  const [deliveryId, setDeliveryId] = useState(null)

  const ReduxDeliveryCharge = useSelector((state: any) => state.main.deliveryCharge)
  const ReduxDeliveryLocation = useSelector((state: any) => state.main.deliveryLocation)
  const ReduxDeliveryChargeText = useSelector((state: any) => state.main.deliveryChargeText)

  const ReduxInvoiceType = useSelector((state: any) => state.main.invoiceType)

  return (
    <setOpenProceed.Provider value={setIsOpenProceed}>
      <Modal
        data-testid="modal"
        closable={false}
        width={770}
        maskClosable={false}
        centered
        onCancel={() => {
          setIsOpenProceed(false);
          document.body.classList.remove("body-scroll-lock");
        }}
        open={isOpenProceed}
        cancelText={t("cancel")}
        okButtonProps={{ style: { display: "none" } }}
        cancelButtonProps={{
          style: {
            color: "#1677FF",
            border: "1px solid #1677FF",
            height: "40px",
            width: "100px",
          },
        }}
        okText={`${t("save")}`}
      >
        <Form id="proceed" form={form} onFinish={() => { }}>
          <Row style={{ marginBottom: "40px" }}>
            <Col offset={1} span={23}>
              <Title title={`${t("proceed-payment")}`} />
            </Col>
            <Col
              offset={1}
              span={22}
              className="modaltitleEdit"
              style={{ marginBottom: "20px" }}
            >
              {t("choose-payment-method")}
            </Col>
            <Col offset={1}>
              <Button
                ref={cashRef}
                form="proceed"
                htmlType="submit"
                className="addbutton"
                style={{ width: "150px", height: "60px", fontSize: "24px" }}
                onClick={() => setIsPayOpen(true)}
              >
                {t("cash")}
              </Button>
            </Col>
            <Col offset={1}>
              <Button
                disabled={!customer?.name || ReduxInvoiceType.id > 0}
                size="large"
                className="addbutton"
                style={
                  !customer?.name || ReduxInvoiceType.id > 0
                    ?
                    {
                      width: "150px",
                      height: "60px",
                      fontSize: "24px",
                      background: "#bdbdbd",
                    } : {
                      width: "150px",
                      height: "60px",
                      fontSize: "24px",
                      background: "#1677FF",
                    }
                }
                onClick={() => setIsOpenDelivery(true)}
              >
                {t("delivery")}
              </Button>
            </Col>
            <Col offset={1}>
              <Button
                disabled={!customer?.name || ReduxInvoiceType.id > 0}
                size="large"
                className="addbutton"
                style={
                  !customer?.name || ReduxInvoiceType.id > 0
                    ? {
                      width: "150px",
                      height: "60px",
                      fontSize: "24px",
                      background: "#bdbdbd",
                    }
                    : {
                      width: "150px",
                      height: "60px",
                      fontSize: "24px",
                      background: "#1677FF",
                    }
                }
                onClick={() => {
                  !!customer?.name && setIsOnAccountOpen(true);
                }}
              >
                {t("on-account")}
              </Button>
            </Col>
            <Col offset={1}>
              <Button
                disabled
                size="large"
                className="addbutton"
                style={{
                  width: "150px",
                  height: "60px",
                  fontSize: "24px",
                  background: "#bdbdbd",
                }}
                onClick={() => setIsOpenCreditCard(true)}
              >
                {t("credit")}
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
      {/*--------------MODALS-------------*/}
      <OnAccount
        isOpen={isOnAccountOpen}
        setIsOpen={setIsOnAccountOpen}
        setIsOpenProceed={setIsOpenProceed}
      />
      <Pay
        isPayOpen={isPayOpen}
        setIsPayOpen={setIsPayOpen}
        handlePay={(changeLBP: string, changeUSD: string) =>
          handleFinalizePayment(
            false,
            items,
            createReceiptMutation,
            customer,
            discount,
            currency,
            tenderedLBP,
            tenderedUSD,
            changeLBP,
            changeUSD,
            exchangeRate,
            sessionId,
            invoiceNo,
            isPaid, // Pass isPaid here
            ReduxDeliveryCharge,
            ReduxDeliveryLocation,
            ReduxDeliveryChargeText
          )
            .then((res) => {
              dispatch(mainActions.setInvoiceNo(res.data.invoiceNo));
              // Handle success
              setIsPaid(true); // Update isPaid based on the result
              message.success(res.data.message)
            })
            .catch(({ response }) => {
              message.error(response.data.message ?? "Check Payment");
            })
        }
        currency={currency}
        isPaid={isPaid} // Pass isPaid as a prop to Pay
        setIsPaid={setIsPaid}
      />
      <Delivery
        isPayOpen={isOpenDelivery}
        setIsPayOpen={setIsOpenDelivery}
        setDeliveryCharge={setDeliveryCharge}
        deliveryCharge={deliveryCharge}
        setDeliveryId={setDeliveryId}
        isLoadingSaleMutation={isLoadingSaleMutation}
        handlePay={() =>
          handleMakePayment(
            true,
            moment().format("MM/DD/YYYY HH:mm:ss"),
            items,
            createSaleMutation,
            customer,
            discount,
            mainCurrency,
            sessionId,
            invoiceNo,
            exchangeRate,
            deliveryCharge,
            deliveryId
          )
            .then((res) => {
              message.success({
                content: res.data.message,
                duration: 3,
                onClick: () => {
                  message.destroy();
                },
              });
              dispatch(mainActions.setInvoiceNo(res.data.invoiceNo))
              setIsOpenDelivery(false);
              document.body.classList.remove("body-scroll-lock");
            })
            .catch(({ response }) => {
              message.error(response.data.message ?? "Check Payment");
            })
        }
        currency={currency}
        isPaid={isPaid} // Pass isPaid as a prop to Pay
        setIsPaid={setIsPaid}
      />
      <CreditCard
        isOpenCrediCard={isOpenCrediCard}
        setIsOpenCreditCard={setIsOpenCreditCard}
        handlePay={() =>
          handleMakePayment(
            false,
            null,
            items,
            createSaleMutation,
            customer,
            discount,
            mainCurrency,
            sessionId,
            invoiceNo,
            exchangeRates
          ).then((res) => {
            setIsPayOpen(false);
            dispatch(mainActions.clearInvoice());
          })
        }
      />
    </setOpenProceed.Provider>
  );
};
